import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { Configuration } from '../Configuration';

const oidcConfig: UserManagerSettings = {
  authority: Configuration.OidcAuthority, // URL of your OIDC provider
  client_id: Configuration.OidcClientId, // Replace with your client ID
  redirect_uri: `${window.location.origin}/auth-callback`,
  post_logout_redirect_uri: `${window.location.origin}`,
  response_type: 'code', // Use "code" for the Authorization Code Flow
  response_mode: 'query',
  scope: 'openid profile email', // Requested scopes (modify as needed)
  userStore: new WebStorageStateStore({ store: window.localStorage }),

  // Amazon Cognito specials:
  revokeTokenTypes: ['refresh_token'],
  automaticSilentRenew: false,
};

export default oidcConfig;
